import React, { useEffect } from "react";
import useMethodAccount from "./hooks/useMethodAccount";
import FutureTicket from "./futureTicket";
import "./style.scss";
import LimitedTicket from "./limitedTicket";
import { HiOutlineTicket } from "react-icons/hi";
import { BiCommentError } from "react-icons/bi";
import { useTranslation } from "react-i18next";

const AccountTickets: React.FC = () => {
  const { tickets, passes, getLimited, getSelect } = useMethodAccount();
  const { t } = useTranslation();

  useEffect(() => {
    getLimited();
    getSelect();
  }, []);

  const refreshTickets = () => {
    setTimeout(() => {
      getLimited();
      getSelect();
    }, 200);
  };

  return (
    <React.Fragment>
      <div className="account-tickets">
        <h3 className="ticket-title flex-start-center">
          <HiOutlineTicket className="icon" />
          {t("bilety_na_wybrany_dzien")}
        </h3>

        <div className="flex-start flex-wrap">
          {tickets.length > 0 ? (
            <React.Fragment>
              {tickets.map((ticket, index) => (
                <div key={index} className="single-ticket-select">
                  <FutureTicket ticket={ticket} refreshTickets={refreshTickets} />
                </div>
              ))}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className="alert alert-yellow">
                <BiCommentError className="alert-icon" />
                <b>{t("brak_biletow")}</b>
              </div>
            </React.Fragment>
          )}
        </div>

        <h3 className="ticket-title flex-start-center">
          <HiOutlineTicket className="icon" />
          {t("bilety_wazne_okreslony_czas")}
        </h3>

        <div className="flex-start flex-wrap">
          {passes.length > 0 ? (
            <React.Fragment>
              {passes.map((ticket, index) => (
                <div key={index} className="single-ticket-limited">
                  <LimitedTicket ticket={ticket} />
                </div>
              ))}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className="alert alert-yellow">
                <BiCommentError className="alert-icon" />
                <b>{t("brak_biletow")}</b>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default AccountTickets;
